export default "__VITE_ASSET__xkEB6FET__"